import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IBulkEmailsSavePayload,
} from '../types';
import {
  BULK_EMAILS_PERMISSIONS,
  BULK_EMAILS_SEND_MUTATION_KEY,
  BULK_EMAILS_SEND_TEST_URL,
  BULK_EMAILS_SEND_URL,
} from '../constants';

export default function useBulkEmailSendMutation(): IContextMutationResult<void, Error, IBulkEmailsSavePayload> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IBulkEmailsSavePayload>({
    mutationKey: [BULK_EMAILS_SEND_MUTATION_KEY],
    mutationFn: ({ isTest, ...payload }) => fetchPost<void>(
      isTest ? BULK_EMAILS_SEND_TEST_URL : BULK_EMAILS_SEND_URL,
      payload,
      {
        permission: BULK_EMAILS_PERMISSIONS.SHOW,
      },
    ),
  });
}
